import { jsxs as _jsxs } from "react/jsx-runtime";
import { SpecraText } from '@mono/ui-components';
import { Testids } from '@mono/ui-selectors';
export function BlackHatEvidence({ evidence }) {
    let provenance = {};
    try {
        const parsed = JSON.parse(evidence.provenanceJson);
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) provenance = parsed;
    } catch  {
    /* Older evidence may have no readable snapshot. */ }
    const labels = {
        claim_type: 'Claim',
        rationale: 'Rationale',
        source_kind: 'Source type',
        stance: 'Stance',
        confidence: 'Confidence',
        inference_assumptions: 'Assumptions',
        supersedes_evidence_id: 'Replaces evidence',
        created_at: 'Recorded'
    };
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": Testids.blackHat.evidence,
        className: "min-w-0 space-y-1 rounded-md border p-2",
        children: [
            /*#__PURE__*/ _jsxs(SpecraText, {
                as: "p",
                className: "[overflow-wrap:anywhere]",
                children: [
                    "Evidence ",
                    evidence.evidenceId,
                    " ·",
                    ' ',
                    evidence.basis === 'assumption' ? 'Assumption — not verified' : evidence.basis || 'Basis unknown'
                ]
            }),
            /*#__PURE__*/ _jsxs(SpecraText, {
                as: "p",
                className: "[overflow-wrap:anywhere]",
                children: [
                    "Source: ",
                    evidence.sourceRef || 'Not recorded'
                ]
            }),
            /*#__PURE__*/ _jsxs(SpecraText, {
                as: "p",
                className: "[overflow-wrap:anywhere]",
                children: [
                    "Date: ",
                    evidence.sourceDate || 'Unknown'
                ]
            }),
            /*#__PURE__*/ _jsxs(SpecraText, {
                as: "p",
                className: "[overflow-wrap:anywhere]",
                children: [
                    "Contributor: ",
                    evidence.actorUserId || 'Unknown'
                ]
            }),
            Object.entries(labels).map(([key, label])=>typeof provenance[key] === 'string' && provenance[key] ? /*#__PURE__*/ _jsxs(SpecraText, {
                    as: "p",
                    className: "whitespace-pre-wrap [overflow-wrap:anywhere]",
                    children: [
                        label,
                        ":",
                        ' ',
                        [
                            'claim_type',
                            'source_kind',
                            'stance',
                            'confidence'
                        ].includes(key) ? String(provenance[key]).replace(/_/g, ' ') : String(provenance[key])
                    ]
                }, key) : null)
        ]
    });
}
